import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <path
        d="m59.33,45.62c3.87-6.36,4.98-14.12,3.06-21.31-3.2-11.95-14.07-20.3-26.45-20.3h-1.79c-14.86,0-26.91,12.05-26.91,26.91v3.05l-5.08,7.81c-.91,1.39-.82,3.29.42,4.64.33.36.75.62,1.19.83l3.6,1.68,1.45,8.23c.73,4.18,4.35,7.22,8.6,7.22h6.69c.88,0,1.64.62,1.82,1.48l1.08,5.2c.12.56.61.96,1.19.96h25.09c.36,0,.7-.16.93-.44.23-.28.32-.65.24-1l-1.63-7.82c-.64-3.1-.09-6.29,1.55-8.99l4.95-8.13Zm-38.22-9.88c-1.14.89-2.61,1.37-4.14,1.37s-3-.49-4.14-1.37c-.52-.41-.61-1.16-.21-1.67.41-.52,1.16-.61,1.67-.21,1.44,1.12,3.9,1.12,5.34,0,.52-.41,1.27-.31,1.67.21.41.52.31,1.27-.21,1.67h0Zm23.75-11.09l-7.77,7.77c-1.12,1.12-2.93,1.12-4.05,0l-7.77-7.77c-2.44-2.44-2.3-6.49.43-8.74,2.38-1.96,5.92-1.61,8.1.57l1.27,1.27,1.27-1.27c2.18-2.18,5.72-2.53,8.1-.57,2.72,2.25,2.87,6.3.42,8.74h0Z"
        fill={colourFill}
      />
    </svg>
  );
};

export default ServiceIcon;
